export interface Yacht {
  id: string;
  name: string;
  price: number;
  year: number;
  length: number;
  builder: string;
  location: string;
  cabins: number;
  guests: number;
  crew: number;
  speed: number;
  image: string;
  description: string;
  features: string[];
  priceDisplay?: string;
}

export const yachtListings: Yacht[] = [
  {
    id: "1",
    name: "EXCELLENCE",
    price: 11500000,
    year: 2010,
    length: 45.7,
    builder: "Richmond Yachts",
    location: "Available",
    cabins: 6,
    guests: 12,
    crew: 11,
    speed: 18,
    image: "https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/4ff70944e597d503d0565003eb1ccc61.jpeg",
    description: "A stunning 149'11\" motor yacht delivered by Richmond Yachts in 2010 and refitted in 2018. Features exceptional interior design by Setzer Design Group with spacious accommodations for 12 guests across 6 luxurious cabins.",
    features: ["Refit 2018", "Beach Club", "Jacuzzi", "Gym", "Entertainment System", "Tender Garage"]
  },
  {
    id: "2",
    name: "PROJECT RAPTOR",
    price: 0,
    priceDisplay: "POA",
    year: 2029,
    length: 97,
    builder: "Custom Built",
    location: "Available",
    cabins: 9,
    guests: 18,
    crew: 20,
    speed: 12,
    image: "https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/20bab62ca649dc390afc9337f729af13.jpeg",
    description: "An extraordinary 318-foot custom-built superyacht scheduled for delivery in 2029. Project Raptor represents the pinnacle of modern yacht design with cutting-edge technology and unparalleled luxury accommodations for 18 guests.",
    features: ["Custom Built", "Steel Hull", "8,000 NM Range", "Advanced Stabilization", "Luxury Spa", "Helipad", "Beach Club", "Cinema"]
  },
  {
    id: "3",
    name: "SIMON FRASER",
    price: 0,
    priceDisplay: "POA",
    year: 2028,
    length: 72.8,
    builder: "Custom Built",
    location: "Italy",
    cabins: 12,
    guests: 12,
    crew: 16,
    speed: 16,
    image: "https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/476681f6b8889136b81a44e374b41868.jpeg",
    description: "A remarkable 239-foot custom-built expedition yacht scheduled for delivery in 2028. Simon Fraser combines robust steel construction with luxurious accommodations, designed for global exploration with ice-class capabilities and extended range.",
    features: ["Custom Built", "Steel Hull", "Ice Class", "Expedition Design", "12 Cabins", "Extended Range", "Beach Club", "Tender Garage"]
  },
  {
    id: "4",
    name: "PROJECT ICE",
    price: 0,
    priceDisplay: "POA",
    year: 2028,
    length: 54,
    builder: "Custom",
    location: "Available",
    cabins: 8,
    guests: 16,
    crew: 12,
    speed: 16,
    image: "https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/476b0f914ae6dd8fb4208725397a4514.jpeg",
    description: "A striking 177-foot custom-built superyacht scheduled for delivery in 2028. Project Ice features bold contemporary design with steel hull construction, offering exceptional range of 7,000 nautical miles and luxurious accommodations for 16 guests across 8 cabins.",
    features: ["Custom Built", "Steel Hull", "7,000 NM Range", "8 Cabins", "16 Guests", "12 Crew", "Beach Club", "Tender Garage"]
  },
  {
    id: "5",
    name: "BELLA",
    price: 8000000,
    year: 2005,
    length: 53.9,
    builder: "Sensation Yachts",
    location: "Available",
    cabins: 6,
    guests: 12,
    crew: 11,
    speed: 16,
    image: "https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/354ee9fb5197097a68d34905c0491308.jpeg",
    description: "A beautiful 177-foot motor yacht built by Sensation Yachts in New Zealand in 2005. Bella features steel hull construction with aluminium superstructure, offering 768 GT of luxurious space for 12 guests across 6 well-appointed cabins.",
    features: ["Steel Hull", "Aluminium Superstructure", "768 GT", "Beach Club", "Extended Range", "Luxury Accommodations"]
  },
  {
    id: "6",
    name: "MILD THING",
    price: 1695000,
    year: 2014,
    length: 19.2,
    builder: "Riva",
    location: "Seattle, WA",
    cabins: 3,
    guests: 6,
    crew: 2,
    speed: 38,
    image: "https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/279dccf10d26f4353e8ab82df6dcfdaf.jpeg",
    description: "A stunning 63-foot Riva Virtus sport yacht built in 2014. This Italian masterpiece combines elegant design with high performance, featuring luxurious accommodations for 6 guests in 3 beautifully appointed cabins. Perfect for those who appreciate speed and style.",
    features: ["High Performance", "Italian Design", "Flybridge", "Tender Garage", "Entertainment System", "Water Sports"]
  },
  {
    id: "7",
    name: "DESERT PEARL",
    price: 0,
    priceDisplay: "POA",
    year: 2030,
    length: 120,
    builder: "Lürssen",
    location: "Available",
    cabins: 8,
    guests: 16,
    crew: 30,
    speed: 16,
    image: "https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/e6554dbb3c517cfab294228bdbe737f1.jpeg",
    description: "An extraordinary 120-meter Lürssen superyacht scheduled for delivery in 2030. Desert Pearl represents the pinnacle of German engineering and luxury yacht design, featuring exceptional volume and state-of-the-art amenities for the most discerning owners.",
    features: ["Lürssen Quality", "120m Length", "Helipad", "Beach Club", "Spa", "Cinema", "Tender Garage", "Extended Range"]
  },
  {
    id: "8",
    name: "SILVER WAVE",
    price: 42000000,
    year: 2019,
    length: 62,
    builder: "Sunseeker",
    location: "Palma, Spain",
    cabins: 5,
    guests: 10,
    crew: 10,
    speed: 20,
    image: "https://public.readdy.ai/ai/img_res/e3e0f06fbe3d3390889f8bf64f82a2f0.jpg",
    description: "Performance-oriented superyacht with sleek British design. Perfect for those who value speed and agility without sacrificing luxury and comfort.",
    features: ["High Speed", "Beach Club", "Jacuzzi", "Gym", "Tender Garage", "Water Toys"]
  },
  {
    id: "9",
    name: "TRANQUILITY",
    price: 81000000,
    year: 2022,
    length: 82,
    builder: "Benetti",
    location: "Genoa, Italy",
    cabins: 6,
    guests: 12,
    crew: 16,
    speed: 15.5,
    image: "https://readdy.ai/api/search-image?query=brand-new-benetti-superyacht-pristine-white-hull-modern-italian-elegance-cruising-at-golden-hour-professional-yacht-photography-minimal-water-background&width=800&height=600&seq=yacht-listing-009&orientation=landscape",
    description: "Brand new delivery featuring the latest in yacht design and technology. Offers exceptional volume and innovative layout with focus on wellness and relaxation.",
    features: ["Wellness Center", "Spa", "Yoga Deck", "Beach Club", "Cinema", "Tender Garage"]
  },
  {
    id: "10",
    name: "EXPLORER",
    price: 58000000,
    year: 2018,
    length: 70,
    builder: "Damen",
    location: "Fort Lauderdale, FL",
    cabins: 5,
    guests: 10,
    crew: 13,
    speed: 14,
    image: "https://readdy.ai/api/search-image?query=expedition-superyacht-damen-style-ice-class-hull-rugged-design-white-and-gray-colors-sailing-in-open-ocean-professional-yacht-photography-simple-background&width=800&height=600&seq=yacht-listing-010&orientation=landscape",
    description: "Ice-class expedition yacht built for global cruising. Features extended range, helicopter hangar, and equipment for diving and water sports in remote locations.",
    features: ["Ice Class", "Helicopter Hangar", "Dive Center", "Extended Range", "Beach Club", "Tender Garage"]
  },
  {
    id: "11",
    name: "CELESTIAL",
    price: 112000000,
    year: 2021,
    length: 92,
    builder: "Oceanco",
    location: "Monaco",
    cabins: 7,
    guests: 14,
    crew: 19,
    speed: 17,
    image: "https://readdy.ai/api/search-image?query=stunning-oceanco-superyacht-white-hull-futuristic-design-sailing-at-sunset-dramatic-lighting-professional-yacht-photography-clean-ocean-background&width=800&height=600&seq=yacht-listing-011&orientation=landscape",
    description: "Architectural masterpiece with award-winning interior design. Features revolutionary glass elevator, infinity pool, and panoramic sky lounge with retractable roof.",
    features: ["Glass Elevator", "Infinity Pool", "Retractable Roof", "Helipad", "Spa", "Cinema"]
  },
  {
    id: "12",
    name: "LEGACY",
    price: 64000000,
    year: 2020,
    length: 74,
    builder: "Feadship",
    location: "Amsterdam, Netherlands",
    cabins: 5,
    guests: 10,
    crew: 14,
    speed: 16,
    image: "https://readdy.ai/api/search-image?query=classic-feadship-superyacht-timeless-white-design-elegant-lines-cruising-in-calm-waters-professional-yacht-photography-minimal-background&width=800&height=600&seq=yacht-listing-012&orientation=landscape",
    description: "Timeless Feadship quality with modern amenities. Features classic exterior styling combined with contemporary interior design and latest navigation technology.",
    features: ["Beach Club", "Jacuzzi", "Gym", "Wine Cellar", "Sky Lounge", "Tender Garage"]
  }
];
